import PropTypes from 'prop-types';
import React from 'react';

const AlertBar = ({ children, alertType, className }) => (
  <div className={`alert alert-${alertType} ${className} alert-dismissible`} role="alert">
    <div className="container text-left">
      { children }
    </div>
  </div>
);

AlertBar.propTypes = {
  children: PropTypes.node,
  alertType: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default AlertBar;



// WEBPACK FOOTER //
// ./src/components/common/AlertBar.js